/* CRO: trust-signal drawer — clicking a PDP trust item (lifetime guarantee,
   repairs, delivery...) slides a panel in from the right, cart-drawer style.
   Content comes from the <template> rendered next to each trigger. */
(function () {
  function ensureDrawer() {
    var d = document.getElementById('CroTrustDrawer');
    if (d) return d;
    d = document.createElement('div');
    d.id = 'CroTrustDrawer';
    d.className = 'cro-trust-drawer';
    d.innerHTML =
      '<div class="cro-trust-drawer__overlay" data-cro-drawer-close></div>' +
      '<aside class="cro-trust-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="CroTrustDrawerTitle" tabindex="-1">' +
      '<div class="cro-trust-drawer__head">' +
      '<h2 class="cro-trust-drawer__title" id="CroTrustDrawerTitle"></h2>' +
      '<button type="button" class="cro-trust-drawer__close" aria-label="Close" data-cro-drawer-close>' +
      '<svg viewBox="0 0 18 18" width="16" height="16" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>' +
      '</button></div>' +
      '<div class="cro-trust-drawer__body"></div>' +
      '</aside>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-cro-drawer-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    return d;
  }

  var lastTrigger = null;

  function open(title, html) {
    var d = ensureDrawer();
    d.querySelector('.cro-trust-drawer__title').textContent = title;
    d.querySelector('.cro-trust-drawer__body').innerHTML = html;
    // force a reflow so the initial off-screen transform is committed,
    // then open — the slide-in transition runs from there
    d.querySelector('.cro-trust-drawer__panel').getBoundingClientRect();
    d.classList.add('is-open');
    document.body.classList.add('cro-trust-drawer-lock');
    d.querySelector('.cro-trust-drawer__panel').focus({ preventScroll: true });
  }

  function close() {
    var d = document.getElementById('CroTrustDrawer');
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.body.classList.remove('cro-trust-drawer-lock');
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cro-trust-target]');
    if (!btn) return;
    e.preventDefault();
    var tpl = document.getElementById(btn.dataset.croTrustTarget);
    if (!tpl) return;
    lastTrigger = btn;
    open(tpl.dataset.title || btn.textContent.trim(), tpl.innerHTML);
  });
})();
